import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFlowStore } from "../components/store";

interface AuthProps<P> {
  children: React.ReactElement<P>;
  option: boolean;
  role?: number;
}

const Auth: React.FC<AuthProps<any>> = ({ children, option, role = 0 }) => {
  const { isAuth, role: userRole, auth } = useFlowStore();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      // await auth();
      try {
        // Check authentication status

      // if (!isAuth) {
        // Call auth to check authentication status with cookies
        await auth();

        // Auth check completed

        // Get the latest auth state after the auth check
        const currentIsAuth = useFlowStore.getState().isAuth;

        if (!currentIsAuth) {
          // User is not authenticated
          if (option) {
            // This route requires authentication, redirect to login
            navigate("/");
            return;
          }
        } else {
          // User is authenticated
          if (role > userRole) {
            // User doesn't have sufficient permissions
            navigate("/error01");
            return;
          } 
        }

        // If we get here, the user can access this route
        setIsLoading(false);
      } catch (error) {
        // If there's an error, assume the user is not authenticated
        if (option) {
          navigate("/");
        } else {
          setIsLoading(false);
        }
      }
    };

    checkAuth();
  }, [isAuth, userRole, auth, navigate, option, role]);

  return isLoading ? null : children;
};

export default Auth;